export default {"src":"/_next/static/media/pandora_amp_logo.eed50cd5.svg","height":20,"width":133};